import NewButton from "./newButton";
import { ButtonTypes } from "../../../Definitions";
import { colors, frames, mediaQueriesNumbers, useMediaQuery } from "../../../Styles";

interface TableButtonProps {
  content: string;
  startEnhancer: string | JSX.Element;
  onClick: () => void;
  disabled: boolean;
  bottomPosition?: number;
  leftPosition?: number;
  gridArea?: string;
  fitTable?: boolean
}

const TableButton = ({ content, startEnhancer, onClick, disabled, gridArea, fitTable = false, bottomPosition = 180, leftPosition = -5}: TableButtonProps) => {
  const horizontal = useMediaQuery(`(max-height: ${mediaQueriesNumbers.horizontalMobileMax}px)`); 

  return (
    // <frames._grid_bluePrintButton_container
    <div
      style={{
        bottom: horizontal&&fitTable ? "0px" : `${bottomPosition}px`,
        left: horizontal&&fitTable ? "50px" : `${leftPosition}px`,
        position: "absolute",
        zIndex: 99,
        width: "fit-content",
        height: "fit-content",
        cursor: "pointer",
        transform: horizontal&&fitTable ? undefined : "rotate(90deg)",
        transformOrigin: "left bottom",
        gridArea: gridArea
      }}
    >
      <NewButton
        content={content}
        startEnhancer={startEnhancer}
        buttonType={ButtonTypes.textButton}
        overrides={{
          baseStyles: {
            backgroundColor: colors.greySecondary,
            padding: "6px 8px",
            borderRadius: "8px 8px 0 0",
            userSelect: "none",
            height: "fit-content",
            borderWidth: horizontal&&fitTable ? "0px" : "0px 0px 5px 0px",
            borderColor: colors.greySecondary,
            borderStyle: "solid"
          },
          hoverStyles: { backgroundColor: colors.greyPrimary, borderColor: colors.greyPrimary, opacity: "1" },
          startEnhancerStyles: { transform: horizontal&&fitTable ? undefined : "rotate(-45deg)" },
        }}
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
};

export default TableButton;
